import * as React from 'react';

import styles from './Logo.scss';

type Props = {
  catalogCode: string;
  variant?: 'header' | 'footer';
};

const LOGO_URL = 'https://images.tanp.jp/gracia.tanp/banners/logo/tanp_logo.png';

const toCatalogTopPath = (catalogCode: string): string => `/catalogs/${encodeURIComponent(catalogCode)}`;

export const Logo = ({ catalogCode, variant = 'header' }: Props): JSX.Element => (
  <a
    className={styles.logoLink}
    href={catalogCode ? toCatalogTopPath(catalogCode) : '/catalogs'}
  >
    <img
      className={[styles.logoImage, variant === 'footer' ? styles.logoImageFooter : styles.logoImageHeader].join(' ')}
      src={LOGO_URL}
      alt="TANP"
      loading="eager"
    />
  </a>
);
